module.exports = __webpack_public_path__ + "img/tick_square_2.40be74f4.svg";